import * as React from "react";

export const DescriptionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M5 11V2L6 2.5L7 2L7.99813 2.5L9.00969 2L10 2.5L10.9934 2L11.9913 2.5L13 2L14.0003 2.5L15 2V9"
      stroke="#646363"
      strokeLinejoin="round"
    />
    <path
      d="M15 9V12.5C15 13.163 14.7366 13.7989 14.2678 14.2678C13.7989 14.7366 13.1631 15 12.5 15V15C11.837 15 11.2011 14.7366 10.7323 14.2678C10.2634 13.7989 10 13.163 10 12.5V11H1.50002C1.4342 10.9994 1.36892 11.012 1.30799 11.0369C1.24706 11.0618 1.19171 11.0986 1.14517 11.1451C1.09862 11.1917 1.06181 11.247 1.03689 11.308C1.01197 11.3689 0.999436 11.4342 1.00002 11.5C1.00002 13.5 1.21064 15 3.50002 15H12.5"
      stroke="#646363"
      strokeLinejoin="round"
    />
    <path
      d="M7 5H13"
      stroke="#646363"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 7.5H13"
      stroke="#646363"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
